<template>
    <div class="multi-complex-items" :class="[key]">
        <el-button @click="addItem">添加</el-button>
        <div
            v-for="(subForm, subIndex) in list"
            :key="subForm.name"
            >
            <div class="multi-complex-items_item">
                <template v-for="(ui) in childrenUI">
                    <el-form-item
                        v-if="ui.isShowFn ? ui.isShowFn(subForm) : true"
                        :class="[ui.component.props.className]"
                        :key="`${subForm.name}-${ui.name}`"
                        :prop="`${key}.${subIndex}.${ui.name}`"
                        :rules="ui.rules"
                        :label-width="genLabelWidth(ui)">
                        <div slot="label" class="field-label" :title="ui.label">{{ ui.label }}</div>
                        <component
                            :ref="ui.name"
                            :ui="ui"
                            :is="ui.component.component"
                            :props="ui.component.props"
                            :value="form[key][subIndex][ui.name]"
                            @change="(v) => form[key][subIndex][ui.name] = v"
                            ></component>
                    </el-form-item>
                </template>
            </div>
            <div style="text-align: right">
                <el-link class="delete-btn" type="danger" @click="delItem(subIndex)" >移 除</el-link>
            </div>
        </div>
       
    </div>
</template>

<script>
import _ from "lodash";
// 多实例的复合型控件
export default {
    props: ['props', 'form'],
    computed: {
        list() {
            return this.form[this.key]
        },
        childrenUI() {
            return this.props?.dataSource?.children || []
        },
        key() {
            return this.props?.name || ''
        }
    },
    methods: {
        genLabelWidth(ui) {
            // if (ui.parentName === 'product_images') {
            //     return '50px'
            // }
            return ''
        },
        addItem() {
            let newItem = {}
            const initValue = (item) => {
                if (item.children?.length) {
                    item.children.forEach(element => {
                        initValue(element)
                    })
                } else {
                    newItem[item.name] = undefined
                }
            }
            this.childrenUI.forEach(initValue)
            this.$emit('change', [...this.list, newItem])
        },
        delItem(index) {
            let copy = _.cloneDeep(this.list)
            copy.splice(index, 1)
            this.$emit('change', copy)
        }
    }
}
</script>
<style lang="scss" scoped>
.multi-complex-items_item {
    border: 1px solid #ccc;
    margin-top: 10px;
    padding: 5px 10px;
    display: flex;
    overflow: auto;

    .delete-btn {
        position: absolute;
        right: -10px;
    }

    & ::v-deep .el-form-item {
        align-items: flex-start !important;
        margin-right: 15px; 
        margin-bottom: 10px;
        &.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
            margin-right: 0px;
        }
    }

    .field-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        display: inline-block;
        vertical-align: middle;
        padding-bottom: 5px;
        text-align: left;
    }
    .is-required {
        .field-label {
            width: 90%;
        }
    }
}
</style>
